import React from "react";
const TrendyHairHighlightWhy = () => {
  return (
    <div className="blogWhat-content">
      <h5>Why Hair Highlights?</h5>
      <p>
        Hair highlights are one of the most versatile and stylish ways to change
        your look. They add depth, movement, and a touch of personality without
        requiring a full hair dye. Whether you opt for a subtle balayage or
        striking streaks, highlights can enhance your natural beauty and
        complement your facial features.
      </p>
      <ul>
        <h4>Benefits of Hair Highlights:</h4>
        <li>
          <h6> Adds dimension and volume to hair</h6>
        </li>
        <li>
          <h6>Enhances natural hair color </h6>
        </li>
        <li>
          <h6>Offers a low-maintenance color option </h6>
        </li>
        <li>
          <h6>Creates a youthful and fresh appearance </h6>
        </li>
        <li>
          <h6>Allows for creative and bold color choices </h6>
        </li>
      </ul>
      <p>
        Let’s dive into the biggest hair highlights color trends for 2025 that
        will be taking salons by storm!
      </p>
    </div>
  );
};

export default TrendyHairHighlightWhy;
